import React from 'react';
import PageRouteContextInterface, { PageRouteAction } from '@app/Interface/PageRouteContextInterface';
import { pageRouteReducer } from './Reducer/PageRouteReducer';
import PageRouteInterface from '@app/Interface/PageRouteInterface';
import UserAuthentication from '@app/Security/UserAuthentication';

const initialPageRoutes: PageRouteInterface[] = [];

const pageRouteInitialState: PageRouteContextInterface = {
    pageRoutes: initialPageRoutes
};

const PageRouteContext = React.createContext<{
    pageRouteState: PageRouteContextInterface;
    pageRouteDispatch: React.Dispatch<PageRouteAction>;
}>({
    pageRouteState: pageRouteInitialState,
    pageRouteDispatch: () => null
});

const PageRouteProvider: React.FC = ({ children }) => {

    const STORAGE_KEY = UserAuthentication.LOCAL_STORAGE_PAGE_ROUTES_DATA;

    const [pageRouteState, pageRouteDispatch] = React.useReducer(pageRouteReducer, pageRouteInitialState, (state) => {

        // 3rd argument tires to get data from local storage
        const persistedData = localStorage.getItem(STORAGE_KEY);

        const persistedPageRoutes: PageRouteInterface[] = persistedData ? JSON.parse(persistedData) : pageRouteInitialState.pageRoutes;

        state.pageRoutes = persistedPageRoutes;

        return { ...state };

    });

    // save state on every change
    React.useEffect(() => {

        localStorage.setItem(STORAGE_KEY, JSON.stringify(pageRouteState.pageRoutes));

    }, [STORAGE_KEY, pageRouteState.pageRoutes]);

    // use the newest data on every localStorage change
    React.useEffect(() => {

        // see: https://developer.mozilla.org/en-US/docs/Web/API/StorageEvent
        window.addEventListener("storage", (event: StorageEvent) => {

            if (event.key === STORAGE_KEY) {

                const persistedData = localStorage.getItem(STORAGE_KEY);

                const newPageRoutesData: PageRouteInterface[] = persistedData ? JSON.parse(persistedData) : null;

                if (newPageRoutesData) {

                    pageRouteDispatch({
                        type: "SYNC_PAGE_ROUTES",
                        payload: newPageRoutesData
                    });

                }

            }

        });

    }, [STORAGE_KEY]);

    return (
        <PageRouteContext.Provider value={{ pageRouteState: pageRouteState, pageRouteDispatch: pageRouteDispatch }}>
            {children}
        </PageRouteContext.Provider>
    );

};

export { PageRouteProvider, PageRouteContext };

